import { addParamToUrl } from 'common/lib/helpers/UrlUtils';

const VIMEO_EMBED = urlPathAndQuery => {
    const path = urlPathAndQuery.split('?')[0];
    const queryString = urlPathAndQuery.split('?')[1] ? `?${urlPathAndQuery.split('?')[1]}` : '';
    const videoId = path.split('/')[0];
    const viewKey = path.split('/')[1];
    if (viewKey) {
        return addParamToUrl(`https://player.vimeo.com/video/${videoId}${queryString}`, 'h', viewKey);
    }

    return `https://player.vimeo.com/video/${videoId}${queryString}`;
};

const YOUTUBE_EMBED = id => `https://www.youtube.com/embed/${id}`;

const categorize = url => {
    if (url.includes('vimeo')) {
        return 'vimeo';
    }
    if (url.includes('youtube')) {
        return 'youtube';
    }
    if (url.includes('youtu.be')) {
        return 'youtu.be';
    }
    if (url.includes('phyron')) {
        return 'phyron';
    }
    if (url.includes('matterport')) {
        return 'matterport';
    }
    if (url.includes('h5property')) {
        return 'h5property';
    }
    if (url.includes('youriguide')) {
        return 'youriguide';
    }
    return null;
};

export const externalMediaUrlGenerator = url => {
    const categorizedUrl = categorize(url);
    const urlWithParams = new URL(url);
    const featuredVideoUrl = url.replace('&feature=youtu.be', '');

    switch (categorizedUrl) {
        case 'vimeo':
            return VIMEO_EMBED(url.split('vimeo.com/')[1]);
        case 'youtube':
            return YOUTUBE_EMBED(featuredVideoUrl.split('?v=')[1]);
        case 'youtu.be':
            return YOUTUBE_EMBED(featuredVideoUrl.split('youtu.be/')[1]);
        case 'phyron':
            // ToDo
            return urlWithParams;
        case 'matterport':
            urlWithParams.searchParams.append('play', '1');
            urlWithParams.searchParams.append('qs', '1');
            urlWithParams.searchParams.append('vr', '0');
            return urlWithParams;
        case 'h5property':
            urlWithParams.searchParams.append('initvars.design', 'finn');
            return urlWithParams;
        case 'youriguide':
            urlWithParams.searchParams.append('mute', '1');
            urlWithParams.searchParams.append('unbranded', '1');
            urlWithParams.searchParams.append('nomenu', '1');
            urlWithParams.searchParams.append('nox', '1');
            urlWithParams.searchParams.append('bgcolor', '000000');
            return urlWithParams;
        default:
            return urlWithParams;
    }
};
